import { useSyncExternalStore } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { RefreshCw } from 'lucide-react';

/**
 * SW kaydı sayfa ömründe BİR kez yapılır. Bant her ekranda (kayıt → üye sayfası) yeniden bağlanır; `useRegisterSW`
 * her bağlanışta yeni Workbox örneği kaydediyordu → ilk kurulumdaki SW "harici" sayılıp ilk ziyarette yanlışlıkla
 * "Yeni sürüm hazır" çıkıyordu. Durum modül düzeyinde tutulur, bantlar yalnız abone olur.
 */
let needRefresh = false;
let update: ((reload?: boolean) => Promise<void>) | null = null;
const listeners = new Set<() => void>();

function set(v: boolean) {
  needRefresh = v;
  listeners.forEach((l) => l());
}

function ensureRegistered() {
  if (update || typeof window === 'undefined') return;
  update = registerSW({
    onNeedRefresh: () => set(true),
    onRegisteredSW(_url, reg) {
      if (reg) window.setInterval(() => void reg.update().catch(() => undefined), 60 * 60_000);
    },
  });
}

function subscribe(l: () => void) {
  ensureRegistered();
  listeners.add(l);
  return () => listeners.delete(l);
}

/**
 * Yeni sürüm bandı. SW 'prompt' modunda: yeni kabuk hazır olunca kullanıcıya sorulur (sipariş ortasında sayfa
 * kendiliğinden yenilenmez). Saatlik güncelleme kontrolü — uzun açık kalan kurulu uygulamalar için.
 */
export function UpdateBanner() {
  const show = useSyncExternalStore(subscribe, () => needRefresh, () => false);
  if (!show) return null;
  return (
    <div className="fixed inset-x-3 top-3 z-[55] mx-auto flex max-w-md animate-rise items-center gap-3 rounded-2xl bg-ink px-4 py-3 text-bg shadow-float pt-safe">
      <RefreshCw className="size-5 shrink-0 text-gold-bright" />
      <p className="min-w-0 flex-1 text-[14px] font-semibold">Yeni sürüm hazır</p>
      <button type="button" onClick={() => set(false)} className="px-2 text-[13px] font-semibold opacity-70">
        Sonra
      </button>
      <button type="button" onClick={() => void update?.(true)} className="gold-fill rounded-xl px-3 py-1.5 text-[13px] font-bold">
        Güncelle
      </button>
    </div>
  );
}
